export function headerInit() {
  let menuTrigger = document.querySelector(".meganenu-expand-trigger");
  let megamenu = document.querySelector(".mega-menu");

  let menuTimeoutRef;

  menuTrigger.addEventListener("mouseover", () => {
    megamenu.classList.add("active");
  });

  menuTrigger.addEventListener("mouseleave", (e) => {
    if (!megamenu.contains(e.relatedTarget)) {
      menuTimeoutRef = setTimeout(() => {
        megamenu.classList.remove("active");
      }, 300);
    }
  });

  megamenu.addEventListener("mouseleave", (e) => {
    if (!menuTrigger.contains(e.relatedTarget)) {
      megamenu.classList.remove("active");
    }
  });

  megamenu.addEventListener("mouseover", (e) => {
    clearTimeout(menuTimeoutRef);
  });
}

export function initMobileMenu() {
  const mobileMenuIcon = document.querySelector(".header__mobile-menu-icon");
  const mobileMenu = document.querySelector(".mobile-menu");

  mobileMenuIcon.addEventListener("click", () => {
    if (mobileMenu.classList.contains("active")) {
      document.querySelectorAll("#menu-mobile-menu .sub-menu.active").forEach((el) => {
        el.classList.remove("active");
      });
    }
    mobileMenu.classList.toggle("active");
    mobileMenuIcon.classList.toggle("active");
    document.body.classList.toggle("no-scroll");
  });

  //Menu submenu icons
  const menuItemsWithChildren = document.querySelectorAll(".mobile-menu .menu-item-has-children");
  menuItemsWithChildren.forEach((item) => {
    const trigger = document.createElement("span");
    trigger.classList.add("submenu-trigger");
    trigger.innerHTML = "<img src='/wp-content/themes/firos/assets/images/firos-chevron.svg'>";
    item.appendChild(trigger);
  });

  //Menu submenu back button
  const submenus = document.querySelectorAll(".mobile-menu .sub-menu");
  submenus.forEach((submenu) => {
    const backButton = document.createElement("li");
    backButton.classList.add("back-button");
    backButton.innerHTML = "<img class='back-button__icon' src='/wp-content/themes/firos/assets/images/arrow.svg'><span>ΠΙΣΩ</span>";
    submenu.insertBefore(backButton, submenu.firstChild);
  });

  //Menu submenu toggle
  const submenuTriggers = document.querySelectorAll(".mobile-menu #menu-mobile-menu .menu-item-has-children");
  submenuTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.stopPropagation(); // prevent bubbling to parent menu items
      //Close sub-menu
      if (e.target.classList.contains("back-button")) {
        const parentSubmenu = e.target.closest(".sub-menu");
        parentSubmenu.classList.remove("active");
        //Parent sub-menu oveflow
        if (e.target.closest(".sub-menu-parent-overflow-hidden") !== null) {
          e.target.closest(".sub-menu-parent-overflow-hidden").classList.remove("sub-menu-parent-overflow-hidden");
        }
        return;
      }
      //Open sub-menu
      const parentItem = e.target.closest(".menu-item-has-children");
      const submenu = parentItem.querySelector(".sub-menu");
      submenu.classList.add("active");
      //Parent sub-menu oveflow
      if (e.target.closest(".sub-menu") !== null) {
        e.target.closest(".sub-menu").classList.add("sub-menu-parent-overflow-hidden");
      }
    });
  });
}
